


















import Vue from "vue";
import GetCatImage from "@/components/GetCatImage";

export default Vue.extend({
  components: {
    "get-cat-image": GetCatImage
  },

  props: {
    title: String,
    breedId: String
  },

  data(): { image: string; temperament: string } {
    return {
      image: "",
      temperament: ""
    };
  }
});
